export const DPS_REPORT_MODULE_KEY = {
  COMMENT: 'comment',
  CHANGES: 'changes',
  MEMO: 'memo',
  CALENDARS: 'calendars',
};

export const DPS_REPORT_MODULE_KEYS = [
  DPS_REPORT_MODULE_KEY.COMMENT,
  DPS_REPORT_MODULE_KEY.CHANGES,
  DPS_REPORT_MODULE_KEY.MEMO,
  DPS_REPORT_MODULE_KEY.CALENDARS,
];
